<template>
  <div class="relative right-0 h-full flex">
    <textarea
      v-model="noteContent"
      class="w-full h-content-headless-toolbox bg-white overflow-y-scroll outline-none resize-none px-1 font-trebuchet-pixel text-md"
    ></textarea>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const noteContent = ref('')

const saveFile = () => {
  if (!noteContent.value.trim()) {
    return
  }

  // Create a blob with the text content
  const blob = new Blob([noteContent.value], { type: 'text/plain' })
  
  // Create a temporary URL for the blob
  const url = URL.createObjectURL(blob)
  
  // Create a temporary anchor element and trigger download
  const link = document.createElement('a')
  link.href = url
  link.download = 'notepad.txt'
  document.body.appendChild(link)
  link.click()
  
  // Clean up
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

// Listen for save event from header menu
const handleSaveEvent = () => {
  saveFile()
}

onMounted(() => {
  window.addEventListener('notepad-save', handleSaveEvent)
})

onUnmounted(() => {
  window.removeEventListener('notepad-save', handleSaveEvent)
})
</script>
